import { UserRoles } from "./auth";
import { ICompany } from "./company";

export enum SpecialPermissions {
  Documentation = "Documentation",
  DietRation = "DietRation",
  Training = "Training",
  PredictionModel = "PredictionModel",
  RdSchedule = "RdSchedule",
  FarmManagement = "FarmManagement",
  IntakeManagement = "IntakeManagement",
}

export const SelectedSuperAdminPermissions = [
  SpecialPermissions.Documentation,
  SpecialPermissions.RdSchedule,
  SpecialPermissions.Training,
  SpecialPermissions.DietRation,
  SpecialPermissions.PredictionModel,
  SpecialPermissions.FarmManagement,
  SpecialPermissions.IntakeManagement,
  
];

export const AllCompanyAllowedSpecialPermissions = [
  SpecialPermissions.Documentation,
];

export const SelectedCompanyAllowedSpecialPermissions = [
  SpecialPermissions.DietRation,
  SpecialPermissions.Training,
];

export enum LimitedPermissions {
  OnlyPricing = "Only Pricing",
}

export const SpecialPermissionToLimitedPermissions = {
  [SpecialPermissions.DietRation]: [LimitedPermissions.OnlyPricing],
};

export interface IPermissionStatus {
  permissionName: SpecialPermissions;
  read?: boolean;
  write?: boolean;
  limitedPermissions?: string[];
}

export interface IUserCreationPayload {
  companyId?: string;
  clientId?: string;
  fullname?: string;
  email?: string;
  role?: UserRoles;
  phone?: string;
  approved?: boolean;
  permissions?: IPermissionStatus[];
  emailNotificationOff?: boolean;
}

export interface IUserPublicProfile {
  _id?: string;
  company?: ICompany;
  fullname?: string;
  email?: string;
  role?: UserRoles;
  phone?: string;
  avatar?: string;
}

export interface IUser {
  company?: ICompany;
  fullname?: string;
  email?: string;
  password?: string;
  approved?: boolean;
  role?: UserRoles;
  phone?: string;
  avatar?: string;
  isConfirmed?: boolean;
  confirmOTP?: string;
  otpTries?: number;
  status?: boolean;
  _id?: string;
  permissions?: IPermissionStatus[];
  emailNotificationOff?: boolean;
}
